import {
  Page,
  Document,
  Text,
  Font,
  PDFViewer,
  View,
  Image,
  Svg,
  Path,
} from '@react-pdf/renderer'
import React, { useEffect, useState } from 'react'
//@ts-ignore
import font from '../../../assets/fonts/OpenSauceSans-Bold.ttf'
//@ts-ignore
import fontRegular from '../../../assets/fonts/OpenSauceSans-Regular.ttf'
import { formatPipe } from '../../../utils/utils'

const BalanceSheetPdf: React.FC<any> = ({ bodyValues = {}, type = '', infoAccount = {}}) => {
  Font.register({
    family: 'Open Sans',
    fonts: [{ src: font }],
  })

  Font.register({
    family: 'Open Sans-normal',
    fonts: [{ src: fontRegular }],
  })

  const getFirstDayOfCurrentDate = () => {
    let date = new Date()
    return `1/${date.getMonth()+1}/${date.getFullYear()}`
  }

  return (
    <Document title={`mayor-analitico`}>
      <Page size="LETTER" style={{ padding: 30 }}>
        <View
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >

{ infoAccount?.image ? (  // Add null check
    <Image 
        src={infoAccount.image}       
        style={{ 
            objectFit: 'contain', 
            width: 80, 
            height: 80 
        }}
    />
) : null }

            <Text
              style={{
                marginBottom: 10,
                fontFamily: 'Open Sans',
                fontSize: 15,
              }}
            >
              {bodyValues?.tenant?.business_name}
            </Text>

            <Text
              style={{
                marginBottom: 10,
                fontFamily: 'Open Sans-normal',
                fontSize: 10,
              }}
            >
              Estado de Situación Financiera
            </Text>

            <Text
              style={{
                marginBottom: 10,
                fontFamily: 'Open Sans-normal',
                fontSize: 10,
              }}
            >
              Fecha: {getFirstDayOfCurrentDate()}
            </Text>
        </View>

        <View style={{ marginTop: 30 }}>
          <View
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
            }}
          >
            <View style={{ width: '25%' }}>
              <Text
                style={{
                  fontFamily: 'Open Sans-normal',
                  fontSize: 12,
                }}
              >
                Cod.
              </Text>
            </View>

            <View style={{ width: '50%' }}>
              <Text
                style={{
                  fontFamily: 'Open Sans-normal',
                  fontSize: 12,
                }}
              >
                Descripción
              </Text>
            </View>

            <View style={{ width: '20%' }}>
              <Text
                style={{
                  fontFamily: 'Open Sans-normal',
                  fontSize: 12,
                  textAlign: 'center',
                }}
              >
                Monto
              </Text>
            </View>
          </View>
        </View>

        <View style={{backgroundColor: '#0033A0', height: 1, width: '100%', marginTop: 15}}>
        </View>

        {bodyValues[type]?.map((v, i) => (
          <View style={{ marginTop: 20 }}>
            <View
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
              }}
            >
              <View style={{ width: '20%' }}>
                <Text
                  style={{
                    fontFamily: 'Open Sans-normal',
                    fontSize: 10,
                  }}
                >
                  {v?.code}
                </Text>
              </View>

              <View style={{ width: '50%' }}>
                <View
                  style={{
                    marginLeft: v?.level * 8,
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center'
                  }}
                >
                  <View style={{marginRight: 5}}>
                  <Svg width={6} height={4} viewBox="0 0 6 4">
                    <Path
                      d="M0.10709 1.32065L2.66661 3.74045C2.70787 3.77943 2.75905 3.81072 2.81664 3.83218C2.87422 3.85363 2.93686 3.86474 3.00024 3.86474C3.06363 3.86474 3.12626 3.85363 3.18385 3.83218C3.24144 3.81072 3.29261 3.77943 3.33387 3.74045L5.89339 1.32065C6.13766 1.08968 5.93514 0.73291 5.55977 0.73291L0.439985 0.73291C0.0646082 0.73291 -0.137912 1.08968 0.10709 1.32065Z"
                      fill="#2A5BC3"
                    />
                  </Svg>
                  </View>
                  <Text
                    style={{
                      fontFamily: 'Open Sans-normal',
                      fontSize: 10,
                    }}
                  >
                    {v?.name}
                  </Text>
                </View>
              </View>

              <View style={{ width: '20%' }}>
                <Text
                  style={{
                    fontFamily: 'Open Sans-normal',
                    fontSize: 10,
                    textAlign: 'center',
                    color: v?.balance?.includes("-") ? 'red' : ''
                  }}
                >
                  {v?.balance?.includes("-") ? `(${formatPipe(v?.balance?.replace('-', ""))})` : `${formatPipe(v?.balance)}`}
                </Text>
              </View>
            </View>
          </View>
        ))}
      </Page>
    </Document>
  )
}

export default BalanceSheetPdf
